import { useEffect, useRef } from 'react';
import useServiceProjectFeatures from '@atlassian/jira-servicedesk-features-store';
import { useSpaStateTransition } from '@atlassian/jira-spa-state-controller/src/components/transition-state/index.tsx';

const useReviseFeaturesResource = () => {
	const [{ isInitialRender }] = useSpaStateTransition();
	const { data, loading, refresh } = useServiceProjectFeatures();
	const isInitialResourceFetchRef = useRef<boolean>(!data && loading);

	useEffect(() => {
		if (!isInitialRender && !isInitialResourceFetchRef.current) {
			refresh();
		}
	}, [isInitialRender, refresh]);
};

export default useReviseFeaturesResource;
